import styled from 'styled-components'

import colors from '@galo-monitor/styles/colors'

export const Container = styled.div`
  margin-left: 25px;
  color: ${ colors.lightGrey4 };
`
